import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ReviewConfig } from './shared/review-document-config.service';
import { ReviewDocumentDataService } from './shared/review-document-data.service';
import { RevisionDocumento } from '../../../shared';
import { Subject } from 'rxjs';
@Component({
  selector: 'iw-review-document',
  templateUrl: './review-document.component.html',
  styleUrls: ['./review-document.component.scss'],
  providers: [ReviewDocumentDataService]
})
export class ReviewDocumentComponent implements OnInit, OnDestroy {
  // informacion de las revisiones
  @Input() data: Array<RevisionDocumento>;
  // nombre del documento
  @Input() nameDucument = 'Documento';
  // informacion de datos a mostrar en la tabla
  source: Array<any> = [];
  // configuracion de la tabla
  settings: any;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // se emite cuando se ejecuta la accion de regresar
  @Output() back: EventEmitter<boolean> = new EventEmitter();

  constructor(private rddc: ReviewDocumentDataService) { }

  ngOnInit() {
    const rc = new ReviewConfig(this.data);
    this.settings = rc.settings;
    rc.accion.subscribe((res: any) => {
      this.download(res);
    });
    this.loadingSource();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Emite el evento de regresar
   *
   * @memberof ReviewDocumentComponent
   */
  closeReview() {
    this.back.emit(true);
  }

  /**
   * Setea la información de los datos a mostrar en la tabla
   *
   * @private
   * @memberof ReviewDocumentComponent
   */
  private loadingSource() {
    this.data.forEach(item => {
      let revision = 'n/a';
      if (item.revision) {
        revision = 'Sí';
      } else {
        revision = 'No';
      }
      const dateReview = new Date(item.fecha);
      this.source.push({
        'reponsable_id': item.reponsable_id,
        'nombre_responsable': item.nombre_responsable,
        'apellidos_responsable': item.apellidos_responsable,
        'descripcion': item.descripcion,
        'fecha': dateReview.toLocaleString(),
        'revision': revision,
        'version': item.version,
        'historial_id': item.historial_id
      });
    });
  }

  /**
   * Valida el documento y emite la acción de descargar
   *
   * @private
   * @param {number} data
   * @returns {*}
   * @memberof ReviewDocumentComponent
   */
  private download(data: number): any {
    this.rddc.dowloadFile(data).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/review-document/review-document.component.ts